/**
 * ⚠️ AUTO-GENERATED FILE - DO NOT EDIT
 *
 * Generated by: sf database-code
 * Generated from database schema
 *
 * To modify: Change the database schema and re-run `sf database-code` (dc). To make a column queryable by index — including boolean/nullable columns — add a single-column Postgres index and re-run `sf dc`; do not hand-edit generated files.
 */

import { isObject, hasPropOfType, UUID, Temporal, type LocalDatabaseTableDefinition } from 'sf-shared';
import type { MealPlanAssignmentBase } from 'shared/dbo/MealPlanAssignment';

export interface MealPlanAssignmentIndexedDb {
	id: string;
	consumableId: string;
	mealDate: string;
	mealId: string;
	created: number;
	lastModified: number;
	shortId: string;
}

export const isMealPlanAssignmentIndexedDb = (obj: unknown): obj is MealPlanAssignmentIndexedDb => {
	if (!isObject(obj)) {
		return false;
	}
	if (hasPropOfType<{ deleted: boolean }>(obj, 'deleted', 'boolean') && obj.deleted) {
		return true;
	}
	if (!hasPropOfType<{ id: unknown }>(obj, 'id') || !(typeof obj.id === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ consumableId: unknown }>(obj, 'consumableId') || !(typeof obj.consumableId === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ mealDate: unknown }>(obj, 'mealDate') || !(typeof obj.mealDate === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ mealId: unknown }>(obj, 'mealId') || !(typeof obj.mealId === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ created: unknown }>(obj, 'created') || !(typeof obj.created === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ lastModified: unknown }>(obj, 'lastModified') || !(typeof obj.lastModified === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ shortId: unknown }>(obj, 'shortId') || !(typeof obj.shortId === 'string')) {
		return false;
	}
	return true;
};

export const baseToIndexedDB = (obj: MealPlanAssignmentBase): MealPlanAssignmentIndexedDb => ({
	id: obj.id.toString(),
	consumableId: obj.consumableId.toString(),
	mealDate: obj.mealDate.toString(),
	mealId: obj.mealId.toString(),
	created: obj.created.epochMilliseconds,
	lastModified: obj.lastModified.epochMilliseconds,
	shortId: obj.id.shortString,
});

export const indexedDBToBase = (obj: MealPlanAssignmentIndexedDb): MealPlanAssignmentBase => ({
	id: UUID.fromString(obj.id),
	consumableId: UUID.fromString(obj.consumableId),
	mealDate: Temporal.PlainDate.from(obj.mealDate),
	mealId: UUID.fromString(obj.mealId),
	created: Temporal.Instant.fromEpochMilliseconds(obj.created),
	lastModified: Temporal.Instant.fromEpochMilliseconds(obj.lastModified),
	objectContext: 'db',
});

export const itdMealPlanAssignment: LocalDatabaseTableDefinition<MealPlanAssignmentBase, MealPlanAssignmentIndexedDb> = {
	tableName: 'mealPlanAssignments',
	indexColumns: ['mealDate'],
	convertToIndexed: baseToIndexedDB,
	convertFromIndexed: indexedDBToBase,
};
